import { PermissionLevels, PermissionTypeEnum } from 'containers/app/app.model';
import {
  getAccountingPermissionLevel,
  getBankingPermissionLevel,
  getCustomerPermissionLevel,
  getInvoicePermissionLevel,
  getJobsPermissionLevel,
  getRefundPermissionLevel,
  getReportsPermissionLevel,
  getTeamSettingPermissionLevel,
  getTipAndServicePermissionLevel
} from 'containers/app/util';
import { PaymentSystem } from 'containers/payouts/constants';
import { PermissionSettingType } from './constants';

export const getPermissionLevel = (
  permissionType: string,
  permissionList,
  paymentSystem: PaymentSystem
): PermissionLevels => {
  switch (permissionType) {
    case PermissionTypeEnum.TEAMSETTINGS:
      return getTeamSettingPermissionLevel(permissionList);

    case PermissionTypeEnum.INVOICE:
      return getInvoicePermissionLevel(permissionList, paymentSystem);

    case PermissionTypeEnum.FEES:
      return getTipAndServicePermissionLevel(permissionList);

    case PermissionTypeEnum.REFUND:
      return getRefundPermissionLevel(permissionList);

    case PermissionTypeEnum.CUSTOMERS:
      return getCustomerPermissionLevel(permissionList);

    case PermissionTypeEnum.BANKING:
      return getBankingPermissionLevel(permissionList);

    case PermissionTypeEnum.JOBS:
      return getJobsPermissionLevel(permissionList);

    case PermissionTypeEnum.ACCOUNTING:
      return getAccountingPermissionLevel(permissionList);

    case PermissionTypeEnum.REPORTS:
      return getReportsPermissionLevel(permissionList);
  }
  return null;
};

export const getPermissionKey = permissionTitle => {
  switch (permissionTitle) {
    case 'Team settings':
      return PermissionSettingType.TEAM_SETTINGS;
    case 'Invoices and Receipts':
      return PermissionSettingType.INVOICES_AND_RECEIPTS;
    case 'Catalog, Payments and Fees':
      return PermissionSettingType.TIPS_AND_FEES;
    case 'Refunds':
      return PermissionSettingType.REFUNDS;
    case 'Customers':
      return PermissionSettingType.CUSTOMERS;
    case 'Banking (Team)':
      return PermissionSettingType.BANKING;
    case 'Jobs':
      return PermissionSettingType.JOB;
    case 'Accounting and Pay':
      return PermissionSettingType.ACCOUNTING;
    case 'Reports':
      return PermissionSettingType.REPORTS;
    default:
      return permissionTitle;
  }
};
